import { RefinementCtx, ZodIssueCode } from 'zod';
import { Paths } from 'type-fest';

import { isBeforeDateTime, isDateTimeValid, mergeDateAndTime } from '@occc-app/lib/date';
import { PUBLISH_BEFORE_EXPIRE } from '@occc-app/lib/constants/validationMessages';
import { ScheduleDatesFormData } from './types';

export const validatePublishBeforeExpire = (data: ScheduleDatesFormData, ctx: RefinementCtx) => {
  const { publishAtDate, publishAtTime, expireAtDate, expireAtTime } = data;

  if (
    !isDateTimeValid(publishAtDate) ||
    !isDateTimeValid(publishAtTime) ||
    !isDateTimeValid(expireAtDate) ||
    !isDateTimeValid(expireAtTime)
  ) {
    return;
  }

  const publishAt = mergeDateAndTime(publishAtDate, publishAtTime);
  const expireAt = mergeDateAndTime(expireAtDate, expireAtTime);

  if (!isBeforeDateTime(publishAt, expireAt)) {
    ctx.addIssue({
      code: ZodIssueCode.custom,
      message: PUBLISH_BEFORE_EXPIRE,
      path: ['publishAtDate' satisfies Paths<ScheduleDatesFormData>],
    });
    ctx.addIssue({
      code: ZodIssueCode.custom,
      message: PUBLISH_BEFORE_EXPIRE,
      path: ['publishAtTime' satisfies Paths<ScheduleDatesFormData>],
    });
    ctx.addIssue({
      code: ZodIssueCode.custom,
      message: PUBLISH_BEFORE_EXPIRE,
      path: ['expireAtDate' satisfies Paths<ScheduleDatesFormData>],
    });
    ctx.addIssue({
      code: ZodIssueCode.custom,
      message: PUBLISH_BEFORE_EXPIRE,
      path: ['expireAtTime' satisfies Paths<ScheduleDatesFormData>],
    });
  }
};
